// Full Price Badge — 25% off badge shown only on items NOT already on a compare-at sale.
// Mirrors the theme's native <on-sale-badge> element: listens for variant:change
// on its associated form and toggles [hidden] accordingly.
class FullPriceBadge extends HTMLElement {
  constructor() {
    super();
    this._onVariantChanged = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener("variant:change", this._onVariantChanged);
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener("variant:change", this._onVariantChanged);
  }
  _onVariantChanged(event) {
    const variant = event.detail.variant;
    this.hidden = variant["compare_at_price"] > variant["price"];
  }
}
if (!window.customElements.get("full-price-badge")) {
  window.customElements.define("full-price-badge", FullPriceBadge);
}
